import { FallbackProps } from 'react-error-boundary'
import { ErrorCode } from '../../constants'
import NotFound from '../not-found'
import PermissionDenied from '../permission-denied'
import ServerError from '../server-error'
import SessionTimeout from '../session-timeout'
import { BodyTextContainer, ContentContainer } from '@msaf/core-react'

export default function ErrorBoundaryFallbackComponent({ error, resetErrorBoundary }: FallbackProps) {
  let component = null
  switch (error.message) {
    case ErrorCode.SESSION_TIMEOUT:
      component = <SessionTimeout />
      break
    case ErrorCode.PERMISSION_DENIED:
      component = <PermissionDenied />
      break
    case ErrorCode.NOT_FOUND:
      component = <NotFound />
      break
    default:
      component = <ServerError resetErrorBoundary={resetErrorBoundary} />
  }
  return (
    <ContentContainer>
      <BodyTextContainer>{component}</BodyTextContainer>
    </ContentContainer>
  )
}
